import { render, staticRenderFns } from "./renewal-order-confirm-recept-modal.vue?vue&type=template&id=fdfa485a"
import script from "./renewal-order-confirm-recept-modal.vue?vue&type=script&lang=js"
export * from "./renewal-order-confirm-recept-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports